// 产品页假变体
const productVariantBtns = document.querySelectorAll('.product-variant-btn')
productVariantBtns.forEach(function (productVariantBtn) {
  productVariantBtn.setAttribute('role', 'tablist')
  const variantItem = productVariantBtn?.querySelectorAll('.item')
  variantItem?.forEach(function (item) {
    item.setAttribute('role', 'tab')
    if (item.classList.contains('active')) {
      item.setAttribute('aria-selected', 'true')
    }
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const skipLinks = document.querySelectorAll('.skip-link')
  skipLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const targetSelector = e.currentTarget.getAttribute('href')
      const target = targetSelector
        ? document.querySelector(targetSelector) ||
          document.querySelector('main')
        : null

      if (!target) {
        return
      }

      e.preventDefault()

      const hadTabIndex = target.hasAttribute('tabindex')
      if (!hadTabIndex) {
        target.setAttribute('tabindex', '-1')
      }

      target.focus()
      target.scrollIntoView()

      if (!hadTabIndex) {
        target.addEventListener(
          'blur',
          () => {
            target.removeAttribute('tabindex')
          },
          { once: true }
        )
      }
    })
  })
})

function announcementAccessFun() {
  document.addEventListener('DOMContentLoaded', function () {
    const announcement = document.getElementById('accessibility-announcement')
    // 创建一个函数来发布声明
    function announceAccessibilityStatement() {
      // 将声明的内容复制到屏幕可见区域
      const visibleAnnouncement = document.createElement('div')
      visibleAnnouncement.style.position = 'absolute'
      visibleAnnouncement.style.top = '0'
      visibleAnnouncement.style.left = '0'
      visibleAnnouncement.style.width = '1px'
      visibleAnnouncement.style.height = '1px'
      visibleAnnouncement.style.overflow = 'hidden'
      visibleAnnouncement.innerHTML = announcement.innerHTML
      document.body.appendChild(visibleAnnouncement)
      // 移除声明内容（可选）
      setTimeout(() => {
        document.body.removeChild(visibleAnnouncement)
      }, 5000) // 保留一段时间以确保屏幕阅读器能够读取
    }

    // 调用函数发布声明
    announceAccessibilityStatement()
  })
}

function setfocusableAccessibility() {
  const lastFocusableElements = document.querySelectorAll(
    '.last-focusable-element'
  )
  lastFocusableElements.forEach((lastFocusableElement) => {
    lastFocusableElement.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        e.preventDefault()
        e.stopPropagation()
        const firstFocusableElement =
          lastFocusableElement.parentElement.querySelector(
            '.first-focusable-element'
          )
        if (firstFocusableElement) {
          firstFocusableElement.focus()
        } else {
          console.warn('no .first-focusable-element')
        }
      }
    })
  })

  const firstFocusableElements = document.querySelectorAll(
    '.first-focusable-element'
  )
  firstFocusableElements.forEach((firstFocusableElement) => {
    firstFocusableElement.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        e.stopPropagation()
        firstFocusableElement.click()
      }
    })
  })
}

function toggleVideo(videoId) {
  const video = document.getElementById(videoId)
  if (video) {
    if (video.paused) {
      video.play()
    } else {
      video.pause()
    }
  }
}
announcementAccessFun()
setfocusableAccessibility()
toggleVideo() // 修复产品模板中划线价和现价不能被聚焦、屏幕阅读器读到的问题-start
;(function () {
  var bundleRootSelector =
    '#rbr-container-element-false, [id^="rbr-container-element-"]'
  var rawPriceSelector = '.rbr-total-box-rawPrice'
  var salePriceSelector = '.rbr-total-box-price'
  var productPriceSelector =
    '[data-price-container] .product_on-sale-price, [data-price-container] #ProductPrice'
  var productComparePriceSelector =
    '[data-price-container] .product_compare-at-price, [data-price-container] #ComparePrice'
  var accessibilityLabelClass = 'rbr-price-accessibility-label'
  var refreshTimer = null

  function getPriceText(element) {
    if (!element) {
      return ''
    }

    var moneyElement = element.querySelector('.money')
    var sourceText = moneyElement
      ? moneyElement.textContent
      : element.textContent

    return sourceText.replace(/\s+/g, ' ').trim()
  }

  function applyFocusablePriceA11y(element, labelPrefix) {
    if (!element) {
      return
    }

    var priceText = getPriceText(element)
    var hiddenLabel = element.querySelector('.' + accessibilityLabelClass)
    var labelId = element.getAttribute('data-price-a11y-label-id')
    var moneyElements = element.querySelectorAll('.money')

    if (!priceText) {
      return
    }

    if (!hiddenLabel) {
      hiddenLabel = document.createElement('span')
      hiddenLabel.className = 'visually-hidden ' + accessibilityLabelClass
      element.insertBefore(hiddenLabel, element.firstChild)
    }

    if (!labelId) {
      labelId =
        'rbr-price-a11y-label-' + Math.random().toString(36).slice(2, 10)
      element.setAttribute('data-price-a11y-label-id', labelId)
    }

    hiddenLabel.id = labelId
    hiddenLabel.textContent = labelPrefix + ': ' + priceText

    element.setAttribute('tabindex', '0')
    element.setAttribute('role', 'group')
    element.setAttribute('aria-labelledby', labelId)
    element.removeAttribute('aria-label')

    moneyElements.forEach(function (moneyElement) {
      moneyElement.setAttribute('aria-hidden', 'true')
    })
  }

  function enhanceBundlePrices(root) {
    if (!root || !root.querySelector) {
      return
    }

    var rawPrice = root.querySelector(rawPriceSelector)
    var salePrice = root.querySelector(salePriceSelector)

    applyFocusablePriceA11y(rawPrice, 'Oorspronkelijke totaalprijs')
    applyFocusablePriceA11y(salePrice, 'Huidige bundelprijs')
  }

  function enhanceAllBundlePrices() {
    var roots = document.querySelectorAll(bundleRootSelector)

    roots.forEach(function (root) {
      enhanceBundlePrices(root)
    })
  }

  function getProductPriceLabel(element) {
    if (!element) {
      return ''
    }

    if (element.classList.contains('product_compare-at-price')) {
      return 'Oorspronkelijke prijs'
    }

    if (element.classList.contains('on-sale')) {
      return 'Huidige prijs'
    }

    var priceContainer = element.closest('[data-price-container]')
    var comparePrice = priceContainer
      ? priceContainer.querySelector('.product_compare-at-price')
      : null

    if (comparePrice && getPriceText(comparePrice)) {
      return 'Huidige prijs'
    }

    return 'Normale prijs'
  }

  function enhanceProductPrice(element) {
    if (!element) {
      return
    }

    applyFocusablePriceA11y(element, getProductPriceLabel(element))
  }

  function enhanceAllProductPrices() {
    var productPrices = document.querySelectorAll(productPriceSelector)
    var comparePrices = document.querySelectorAll(productComparePriceSelector)

    productPrices.forEach(function (price) {
      enhanceProductPrice(price)
    })

    comparePrices.forEach(function (comparePrice) {
      enhanceProductPrice(comparePrice)
    })
  }

  function isOwnAccessibilityNode(node) {
    return (
      node &&
      node.nodeType === 1 &&
      node.classList &&
      node.classList.contains(accessibilityLabelClass)
    )
  }

  function scheduleEnhancement() {
    if (refreshTimer) {
      window.clearTimeout(refreshTimer)
    }

    refreshTimer = window.setTimeout(function () {
      refreshTimer = null
      enhanceAllBundlePrices()
      enhanceAllProductPrices()
    }, 80)
  }

  function shouldHandleMutation(mutation) {
    if (!mutation.target) {
      return false
    }

    if (
      mutation.target.nodeType === 1 &&
      mutation.target.matches &&
      (mutation.target.matches(rawPriceSelector) ||
        mutation.target.matches(salePriceSelector) ||
        mutation.target.matches(productPriceSelector) ||
        mutation.target.matches(productComparePriceSelector) ||
        mutation.target.closest(rawPriceSelector) ||
        mutation.target.closest(salePriceSelector) ||
        mutation.target.closest(productPriceSelector) ||
        mutation.target.closest(productComparePriceSelector))
    ) {
      return true
    }

    return Array.prototype.some.call(mutation.addedNodes, function (node) {
      if (isOwnAccessibilityNode(node)) {
        return false
      }

      return (
        node.nodeType === 1 &&
        (node.matches(bundleRootSelector) ||
          node.matches(productPriceSelector) ||
          node.matches(productComparePriceSelector) ||
          node.querySelector(rawPriceSelector) ||
          node.querySelector(salePriceSelector) ||
          node.querySelector(productPriceSelector) ||
          node.querySelector(productComparePriceSelector))
      )
    })
  }

  function observeBundlePrices() {
    if (!document.body || typeof MutationObserver === 'undefined') {
      return
    }

    var observer = new MutationObserver(function (mutations) {
      var needsRefresh = mutations.some(shouldHandleMutation)

      if (needsRefresh) {
        scheduleEnhancement()
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceAllBundlePrices()
      enhanceAllProductPrices()
      observeBundlePrices()
    })
  } else {
    enhanceAllBundlePrices()
    enhanceAllProductPrices()
    observeBundlePrices()
  }
})()
// 修复产品模板中划线价和现价不能被聚焦、屏幕阅读器读到的问题-end
